import { NearMeIcon } from "components/icons"
import { Button } from "@mui/material"
import { useTranslation } from "providers/i18n"

export const StartButton = ({ label = "Start", ...props }) => {
  const { t } = useTranslation()
  return (
    <Button variant="contained" startIcon={<NearMeIcon />} {...props}>
      {t(label)}
    </Button>
  )
}
